import React, { useState, useEffect } from "react";
import {
  Input,
  FormControl,
  InputLabel,
  InputAdornment,
  IconButton,
  Card,
  Typography,
  Box,
  Stack,
} from "@mui/material";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import LoginButton from "../loginButton/LoginButton.js";
import { useNavigate, useLocation } from "react-router";

const ResetCard = () => {
  const [showPassword, setShowPassword] = useState(false);
  const [newPassword, setNewPassword] = useState("");
  const [confirmnewPassword, setConfirmNewPassword] = useState("");
  const [token, setToken] = useState("");
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const tokenFromURL = queryParams.get("token");
    setToken(tokenFromURL);
  }, [location.search]);

  const handleClickShowPassword = () => setShowPassword((show) => !show);
  const handleMouseDownPassword = (event) => event.preventDefault();

  const onPasswordChange = (e) => {
    setNewPassword(e.target.value.toUpperCase());
  };

  const onConfirmPasswordChange = (e) => {
    setConfirmNewPassword(e.target.value.toUpperCase());
  };

  const submitFunction = async() => {
    if (newPassword !== confirmnewPassword) {
      alert("New Password and Confirm Password should be the same");
      return;
    }

    try {
        const response = await fetch(`${process.env.REACT_APP_BASE_URL}/api/auth/reset-password`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ token, newPassword }),
        });
    
        const data = await response.json();
    
        if (!response.ok) {
          if (data.message) {
            alert(data.message); 
          } else {
            alert("Something went wrong. Please try again.");
          }
          return;
        }
        alert("Password reset successful!");
        navigate("/");
      } catch (error) {
        console.error("Reset password failed:", error);
        alert("Something went wrong. Please try again.");
      }
  };

  return (
    <Box
        sx={{
        backgroundColor: "#1c6685",
        minHeight: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        }}
    >
      <Card variant="outlined" sx={{ p: 4, width: 350 }}>
        <Stack spacing={3}>
          <Typography variant="h6" textAlign="center">
            Reset Your Password
          </Typography>

          <FormControl variant="standard" required>
            <InputLabel>New Password</InputLabel>
            <Input
              type={showPassword ? "text" : "password"}
              value={newPassword}
              onChange={onPasswordChange}
              endAdornment={
                <InputAdornment position="end">
                  <IconButton
                    onClick={handleClickShowPassword}
                    onMouseDown={handleMouseDownPassword}
                  >
                    {showPassword ? <Visibility /> : <VisibilityOff />}
                  </IconButton>
                </InputAdornment>
              }
            />
          </FormControl>

          <FormControl variant="standard" required>
            <InputLabel>Confirm New Password</InputLabel>
            <Input
              type={showPassword ? "text" : "password"}
              value={confirmnewPassword}
              onChange={onConfirmPasswordChange}
              endAdornment={
                <InputAdornment position="end">
                  <IconButton
                    onClick={handleClickShowPassword}
                    onMouseDown={handleMouseDownPassword}
                  >
                    {showPassword ? <Visibility /> : <VisibilityOff />}
                  </IconButton>
                </InputAdornment>
              }
            />
          </FormControl>

          {/* Centered Submit Button */}
          <Box display="flex" justifyContent="center">
            <LoginButton name="Submit" submit={submitFunction} />
          </Box>
        </Stack>
      </Card>
    </Box>
  );
};

export default ResetCard;
